var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:({ backgroundColor: _vm.getStatusColor(_vm.status) })},[_c('div',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.getStatusText(_vm.status))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }